import { render, staticRenderFns } from "./Aktuelles.vue?vue&type=template&id=e67281ac&scoped=true&"
import script from "./Aktuelles.vue?vue&type=script&lang=js&"
export * from "./Aktuelles.vue?vue&type=script&lang=js&"
import style0 from "./Aktuelles.vue?vue&type=style&index=0&id=e67281ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67281ac",
  null
  
)

export default component.exports